<template>
    <div>
        <h3 class="grey-color mb-3 main_text font-weight-bold">Личный кабинет</h3>

        <b-card class="my-2">
            <b-button variant="custom-outline-secondary" class="text-uppercase" href="https://info.zakupschik.ru/files/download/8685f9ea-198b-11f1-8f50-fa163e2ff576" target="_blank"><b-icon icon="exclamation-circle" class="mr-2" />Памятка по работе в ИС АТМО</b-button>
        </b-card>

        <h4 class="grey-color my-3 main_text font-weight-bold">Состояние лицевого счета:</h4>
        <b-row class="border-bottom my-2 account_block" no-gutters v-if="balance">
            <b-col lg="4" class="my-2">
                <div class="d-flex flex-column align-items-center px-3">
                    <div class="cust_label total">
                        {{ $formatPrice(balance.total) }}
                    </div>
                    <p class="mt-2 mb-0 text-center fs-14 grey-color">Депозит</p>
                </div>
            </b-col>
            <b-col lg="4" class="my-2">
                <div class="d-flex flex-column align-items-center px-3">
                    <div class="cust_label available">
                        {{ $formatPrice(balance.available) }}
                    </div>
                    <p class="mt-2 mb-0 text-center fs-14 grey-color">Доступные</p>
                </div>
            </b-col>
            <b-col lg="4" class="my-2">
                <div class="d-flex flex-column align-items-center px-3">
                    <div class="cust_label blocked">
                        {{ $formatPrice(balance.blocked) }}
                    </div>
                    <p class="mt-2 mb-0 text-center fs-14 grey-color">Заблокированные</p>
                </div>
            </b-col>
        </b-row>

        <b-button variant="custom-green" class="text-uppercase my-2" :to="{ name: 'CabinetAccountingReconciliationReports' }"> Акты сверки </b-button>

        <b-card class="my-2" v-if="$store.getters.getCertificateNeedToBeProlonged">
            <p class="text-danger font-weight-bold py-0 my-0">Срок действия вашей ЭЦП истекает {{ getDateTimeFormat($store.getters.getCertificateValidTo) }}.</p>
        </b-card>

        <b-card class="my-2" v-if="$store.getters.getPOANeedToBeProlonged">
            <p class="text-danger font-weight-bold py-0 my-0">Срок действия вашей МЧД истекает {{ getDateTimeFormat($store.getters.getPOAValidTo) }}.</p>
        </b-card>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Личный кабинет'
    },
    name: 'CabinetHome',
    computed: {
        balance() {
            return this.$store.getters.getAccounting;
        }
    }
};
</script>

<style scoped>
.cust_label {
    min-width: 169px;
    width: 100%;
    border-radius: 4px;
    text-align: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 20px;
    padding: 7px 34px;
    white-space: nowrap;
}
.available {
    background-color: var(--green-color);
}
.total {
    background-color: #959ba4;
}
.blocked {
    background-color: #f6b33a;
}
.account_block {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
